import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'teacherName',
      type: 'input',
      label: '直播老师',
      placeholder: '请输入老师名称'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
